import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

Fancybox.bind('[data-fancybox="video"]', {
    Image: {
      zoom: true,
    },
  });

  Fancybox.bind('[data-fancybox="videoMobile"]', {
    Image: {
      zoom: false,
    },
  });
